import { useState, useEffect, useCallback } from "react";
import { supabase } from "../supabaseClient";
import { useAuth } from "../AuthContext";

export default function useNickname() {
  const { user } = useAuth();
  const [nickname, setNickname] = useState(null);
  const [loading, setLoading]   = useState(true);

  const fetchNickname = useCallback(async () => {
    if (!user?.id) {
      setNickname(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data } = await supabase
      .from("profiles")
      .select("nickname")
      .eq("user_id", user.id)
      .maybeSingle();

    setNickname(data?.nickname || null);
    setLoading(false);
  }, [user?.id]);

  useEffect(() => {
    fetchNickname();
  }, [fetchNickname]);

  return { nickname, loading, refetch: fetchNickname };
}
